import React, { useContext, useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../../BaseUrl";

//functions
import {
  _t,
  getCookie,
  tableLoading,
  customStyle,
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";
import { useCustomHooks } from "../../../../../functions/Hooks";

//3rd party packages
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// import { useReactToPrint } from "react-to-print";
// import StockReport from "./StockReport";
//pages & includes
import ManageSidebar from "../ManageSidebar";

//context consumer
import { RestaurantContext } from "../../../../../contexts/Restaurant";
import { FoodContext } from "../../../../../contexts/Food";

const StoreRequisitionDeptAction = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const {id} = useParams();
  const { qtyAmountPoints, roundOffStock } = useCustomHooks();
  //getting context values here
  let {
    loading,
    setLoading,
    ingredientItemForSearch,
  } = useContext(RestaurantContext);
  const { foodDeptForSearch } = useContext(FoodContext);

  // States hook here
  //new item
  let [newStoreRequisition, setNewStoreRequisition] = useState({
    document_no: "",
    fdept: null,
    tdept: null,
    remarks: "",
  });
  //new Row
  const [newRow, setNewRow] = useState([]);

  const hanldeSetEdit = (editStore) => {
    if (editStore && editStore !== null) {
      let docDate = new Date(editStore.document_date);

      setNewStoreRequisition({
        ...newStoreRequisition,
        document_no: editStore.document_identity,
        fdept: editStore.from_dept,
        tdept: editStore.to_dept,
        remarks: editStore.remarks,
        is_post: editStore.is_post,
      });
      setDocumentDate(docDate);
      let rowArr = [];
      if (
        editStore.store_requisition_detail &&
        editStore.store_requisition_detail.length > 0
      ) {
        editStore.store_requisition_detail.map((item) => {
          rowArr.push({
            id: rowId.current,
            item_name: {
              ...item,
              id: item.item_id,
              name: item.item_name,
            },
            qty: roundOffStock(item.qty),
            unit: {
              id: item.unit_id,
              name: item.unit_name,
            },
          });
          rowId.current += 1;
        });
        setNewRow([...rowArr]);
      }
    }
  };

  //Get Specific item for edit
  const getOpeningStockItem = async () => {
    setLoading(true);
    const url = BASE_URL + "/settings/storeRequisition/" + parseInt(id);
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      if (res) {
        hanldeSetEdit(res.data);
      }
      setLoading(false);
    } catch {
      setLoading(false);
    }
  };

  useEffect(() => {
    id && getOpeningStockItem();
  }, []);

  let common_toast = {
    position: "bottom-center",
    autoClose: 10000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    className: "text-center toast-notification",
  };

  //datepicker
  const [documentDate, setDocumentDate] = useState(new Date());

  //set items hook
  const handleSetItems = async (index, item) => {
    newRow[index].unit = "";
    //   newRow[index].base_unit="";
    //   newRow[index].base_qty="";
    //   newRow[index].conversion_qty="";
    newRow[index].item_name = item;
    newRow[index].qty = "";
    setNewRow([...newRow]);
    const url = BASE_URL + "/settings/get-unit_item/" + item.id;
    await axios
      .get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        if (res.data) {
          newRow[index].unit = res.data[0];
          setNewRow([...newRow]);
        }
      })
      .catch((error) => {
        console.log("check error", error);
      });
  };

  const [rowId, setRowId] = useState(0);
  const addNewRow = () => {
    if (
      newStoreRequisition.fdept !== null &&
      newStoreRequisition.tdept !== null
    ) {
      setNewRow((pre) => [
        ...pre,
        {
          id: rowId,
          item_name: "",
          qty: "",
          unit: "",
          item_units: "",
        },
      ]);
      setRowId(rowId + 1);
    } else {
      toast.error(`${_t(t("Please select both branches"))}`, {
        position: "bottom-center",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
    }
  };

  const delRow = (id) => {
    let row = [...newRow];
    row = row.filter((item, i) => id !== item.id);
    setNewRow(row);
  };

  // total amount
  // const handleAmount = () => {
  //   let total = 0;
  //   if (newRow !== null && newRow.length>0) {
  //     newRow.map((item) => {
  //       if (parseFloat(item.qty) && parseFloat(item.rate)) {
  //         total = total +  parseFloat(item.qty) * parseFloat(item.rate);
  //       }
  //     });
  //   }
  //   return total;
  // };

  //subtotal
  // const handleGetAmount = (index) => {
  //   let qty = 0;
  //   let rate = 0;
  //   if (newRow !== null && newRow[index].qty !== "") {
  //     qty = parseFloat(newRow[index].qty);
  //   }
  //   if (newRow !== null && newRow[index].rate !== "") {
  //     rate = parseFloat(newRow[index].rate);
  //   }
  //   return rate * qty;
  // };

  //set each item qty
  const handleItemQty = (index, e) => {
    newRow[index].qty = e.target.value;
    setNewRow([...newRow]);
  };

  //handle Set branch hook
  const handleSetDept = (fdept) => {
    newStoreRequisition.tdept = null;
    setNewStoreRequisition({ ...newStoreRequisition, fdept });
  };

  const handleSetToDept = (tdept) => {
    setNewStoreRequisition({ ...newStoreRequisition, tdept });
  };

  const handleRemarks = (e) => {
    setNewStoreRequisition({ ...newStoreRequisition, remarks: e.target.value });
  };

  //post req of stock item add
  const storeItemAxios = async () => {
    let date =
      new Date(documentDate).getFullYear() +
      "-" +
      (new Date(documentDate).getMonth() + 1) +
      "-" +
      new Date(documentDate).getDate();

    let slugArray = [];
    let duplicate = {};
    const duplicateItem = [];
    newRow.map((newStoreItem, index) => {
      if (duplicate[newStoreItem.item_name.id]) {
        duplicateItem.push({
          item_id: newStoreItem.item_name.id,
          item_name: newStoreItem.item_name.name,
        });
      }
      if (newStoreItem.item_name === "" || newStoreItem.unit === "") {
        //   toast.error(`${_t(t("Please select all dropdowns"))}`, common_toast);
        slugArray.push();
      } else {
        duplicate[newStoreItem.item_name.id] = true;
        slugArray.push({
          qty: parseFloat(newStoreItem.qty),
          item_id: newStoreItem.item_name.id,
          item_name: newStoreItem.item_name.name,
          unit_id: newStoreItem.unit.id,
          unit_name: newStoreItem.unit.name,
        });
      }
    });

    if (duplicateItem?.length) {
      toast.error(
        `${_t(t(`Duplicate item ${duplicateItem[0].item_name} found`))}`,
        common_toast
      );
      return;
    }

    if (newRow.length === slugArray.length) {
      setLoading(true);
      let formData = {
        from_dept_id: newStoreRequisition.fdept.id,
        to_dept_id: newStoreRequisition.tdept.id,
        document_date: date,
        remarks: newStoreRequisition.remarks,
        items: slugArray,
      };
      const url = BASE_URL + "/settings/storeRequisition";

      try {
        const res = await axios.post(url, formData, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        });
        setLoading(false);
        toast.success(`${_t(t("Store Requisition has been added"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
        history.push("/dashboard/manage/stock/store-requisition-dept");
      } catch (error) {
        console.log("check error==>", error);
        setLoading(false);
        toast.error(`${_t(t("Please try again later"))}`, common_toast);
      }
    } else {
      toast.error(`${_t(t("Please select all dropdowns"))}`, common_toast);
    }
  };

  //send to server
  const handleSubmit = (e) => {
    e.preventDefault();
    if (
      newStoreRequisition.fdept !== null &&
      newStoreRequisition.tdept !== null &&
      newStoreRequisition.document_no !== null &&
      documentDate !== null
    ) {
      if (newRow.length > 0) {
        storeItemAxios();
      } else {
        toast.error(`${_t(t("Please add stocks"))}`, common_toast);
      }
    } else {
      toast.error(
        `${_t(t("Please fill all the required fields"))}`,
        common_toast
      );
    }
  };

  return (
    <>
      <Helmet>
        <title>{_t(t("Add Store Requisition Dept"))}</title>
      </Helmet>

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ManageSidebar />
            </div>
            {/* left Sidebar ends */}

            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div
                  className="fk-scroll--pos-menu table-bottom-info-hide"
                  data-simplebar
                >
                  <div className="t-pl-15 t-pr-15">
                    {/* Loading effect */}
                    {loading === true ? (
                      tableLoading()
                    ) : (
                      <div key="smtp-form">
                        <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                          <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0">
                            <ul className="t-list fk-breadcrumb">
                              <li className="fk-breadcrumb__list">
                                <span className="t-link fk-breadcrumb__link text-capitalize">
                                  {_t(t(newStoreRequisition?.is_post ? "View Store Requisition Dept" : "Add Store Requisition Dept"))}
                                </span>
                              </li>
                            </ul>
                          </div>
                          <div className="col-md-6 col-lg-7">
                            <div className="row gx-3 align-items-center"></div>
                          </div>
                        </div>

                        {/* Form starts here */}
                        <form
                          className="row card p-2 mx-3 mb-5 table-text"
                          onSubmit={handleSubmit}
                          autoComplete="off"
                        >
                          <div className="col-12">
                            <div className="row">
                              <div className="form-group col-4 mt-3">
                                <div className="mb-2">
                                  <label
                                    htmlFor="document no"
                                    className="control-label"
                                  >
                                    {_t(t("Document no"))}
                                    <span className="text-danger">*</span>
                                  </label>
                                </div>
                                <div className="mb-2">
                                  <input
                                    readOnly
                                    type="text"
                                    className="form-control table-text"
                                    id="document_no"
                                    name="document_no"
                                    placeholder="Auto no"
                                    required
                                  />
                                </div>
                              </div>

                              <div className="form-group col-4 text-right mt-3">
                                <div className="mb-2 text-left">
                                  <label
                                    htmlFor="transfer_date"
                                    className="control-label"
                                  >
                                    {_t(t("Document Date"))}
                                    <span className="text-danger">*</span>
                                  </label>
                                </div>
                                <div className="mb-2">
                                  <DatePicker
                                    selected={documentDate}
                                    onChange={(date) => setDocumentDate(date)}
                                    peekNextMonth
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    className="form-control table-text"
                                    placeholderText={_t(t("Document date"))}
                                    shouldCloseOnSelect={false}
                                    required
                                  />
                                </div>
                              </div>

                              <div className="form-group mt-3 col-4">
                                <div className="mb-1 text-left">
                                  <label
                                    htmlFor="dept"
                                    className="control-label text-truncate"
                                  >
                                    {_t(t("From Department"))}
                                    <span className="text-danger">*</span>
                                  </label>
                                </div>
                                <Select
                                  options={foodDeptForSearch || []}
                                  components={makeAnimated()}
                                  getOptionLabel={(option) => option.name}
                                  getOptionValue={(option) => option.id}
                                  value={newStoreRequisition.dept || ""}
                                  isDisabled={id}
                                  classNamePrefix="select"
                                  onChange={handleSetDept}
                                  maxMenuHeight="200px"
                                  placeholder={
                                    _t(t("Please select dept")) + ".."
                                  }
                                  styles={customStyle}
                                  required
                                />
                              </div>

                            </div>

                            <div className="row">
                              <div className="form-group mt-2 col-4">
                                <div className="mb-2">
                                  <label
                                    htmlFor="dept"
                                    className="control-label"
                                  >
                                    {_t(t("To Department"))}
                                    <span className="text-danger">*</span>
                                  </label>
                                </div>
                                <Select
                                  options={
                                    foodDeptForSearch
                                      ? foodDeptForSearch.filter(
                                          (item) =>
                                            item.id !==
                                            newStoreRequisition?.fdept?.id
                                        )
                                      : []
                                  }
                                  components={makeAnimated()}
                                  getOptionLabel={(option) => option.name}
                                  getOptionValue={(option) => option.id}
                                  value={newStoreRequisition.tdept || null}
                                  classNamePrefix="select"
                                  onChange={handleSetToDept}
                                  maxMenuHeight="200px"
                                  styles={customStyle}
                                  placeholder={_t(t("Please to dept")) + ".."}
                                  isDisabled={
                                    newStoreRequisition?.fdept ? false : true
                                  }
                                />
                              </div>
                              <div className="form-group mt-2 col-8">
                                <div className="mb-2">
                                  <label
                                    htmlFor="remarks"
                                    className="control-label"
                                  >
                                    {_t(t("Remarks"))}
                                  </label>
                                </div>
                                <div className="mb-2">
                                  <textarea
                                    type="text"
                                    className="form-control table-text"
                                    id="remarks"
                                    name="remarks"
                                    onChange={handleRemarks}
                                    value={newStoreRequisition.remarks || ""}
                                    placeholder="Remarks"
                                    style={{ height: "33px" }}
                                  />
                                </div>
                              </div>
                            </div>

                            <div
                              className={`table-responsive mt-3 pr-1 `}
                              style={{ maxHeight: "23rem", overflow: "auto" }}
                            >
                              <table className="table table-bordered-sm table-hover">
                                <thead className="align-middle">
                                  <tr>
                                    {newRow.length == 0 ? (
                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      >
                                        <span
                                          className="t-mr-10"
                                          onClick={() => addNewRow()}
                                        >
                                          <i
                                            className="fa fa-plus-circle cursor-pointer btn-add-icon"
                                            style={{ fontSize: "22px" }}
                                            aria-hidden="true"
                                          ></i>
                                        </span>
                                      </th>
                                    ) : (
                                      <th
                                        style={{
                                          borderBottomColor: "lightgray",
                                        }}
                                      ></th>
                                    )}
                                    <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border table_child"
                                    >
                                      <span style={{ fontWeight: 500 }}>
                                        {_t(t("Item Name"))}
                                      </span>
                                    </th>

                                    <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                    >
                                      <span style={{ fontWeight: 500 }}>
                                        {_t(t("Qty"))}
                                      </span>
                                    </th>

                                    <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                    >
                                      <span style={{ fontWeight: 500 }}>
                                        {_t(t("Unit"))}
                                      </span>
                                    </th>

                                    {/* <th
                                          scope="col"
                                          className="table-text text-capitalize align-middle text-center border-1 border"
                                        >
                                          <span style={{fontWeight:500}}>
                                          {_t(t("Rate"))}
                                          </span>
                                        </th> */}

                                    {/* <th
                                          scope="col"
                                          className="table-text text-capitalize align-middle text-center border-1 border"
                                        >
                                          <span style={{fontWeight:500}}>
                                          {_t(t("Amount"))}
                                          </span>
                                        </th>                                       */}

                                    {/* <th
                                          scope="col"
                                          className="table-text text-capitalize align-middle text-center border-1 border"
                                        >
                                          <span style={{fontWeight:500}}>
                                          {_t(t("Base unit"))}
                                          </span>
                                        </th>

                                        <th
                                          scope="col"
                                          className="table-text text-capitalize align-middle text-center border-1 border"
                                        >
                                          <span style={{fontWeight:500}}>
                                          {_t(t("Base qty"))}
                                          </span>
                                        </th>

                                        <th
                                          scope="col"
                                          className="table-text text-capitalize align-middle text-center border-1 border"
                                          style={{minWidth:"9rem"}}
                                        >
                                          <span style={{fontWeight:500}}>
                                          {_t(t("Conversion unit"))}
                                          </span>
                                        </th> */}
                                    {newRow.length > 0 && (
                                      <th
                                        style={{
                                          borderBottomColor: "lightgray",
                                          minWidth: "60px",
                                        }}
                                      ></th>
                                    )}
                                  </tr>
                                </thead>
                                {newRow && newRow.length > 0 ? (
                                  <tbody className="align-middle">
                                    {newRow.map((item, index) => {
                                      return (
                                        <tr
                                          className="align-middle"
                                          key={index}
                                        >
                                          <td
                                            className="table-text text-capitalize align-middle text-center table-firstChild"
                                            style={{ minWidth: "60px" }}
                                          >
                                            {index == newRow.length - 1 && (
                                              <span
                                                className="t-mr-10"
                                                onClick={() => addNewRow()}
                                              >
                                                <i
                                                  className="fa fa-plus-circle btn-add-icon"
                                                  style={{ fontSize: "22px" }}
                                                  aria-hidden="true"
                                                ></i>
                                              </span>
                                            )}
                                            &nbsp;
                                            <i
                                              className="fa fa-minus-circle cursor-pointer text-danger"
                                              style={{ fontSize: "22px" }}
                                              onClick={() => {
                                                delRow(item.id);
                                              }}
                                            ></i>
                                          </td>
                                          <td className="table-text text-capitalize align-middle text-center">
                                            <Select
                                              options={
                                                ingredientItemForSearch !== null
                                                  ? ingredientItemForSearch
                                                  : []
                                              }
                                              components={makeAnimated()}
                                              getOptionLabel={(option) =>
                                                option.name
                                              }
                                              getOptionValue={(option) =>
                                                option.id
                                              }
                                              classNamePrefix="select"
                                              onChange={(e) =>
                                                handleSetItems(index, e)
                                              }
                                              maxMenuHeight="12.8rem"
                                              value={item.item_name}
                                              styles={customStyle}
                                              isMenuOpen={true}
                                              menuPosition="fixed"
                                              className="bank-table-input"
                                              placeholder={
                                                _t(t("Please select items")) +
                                                ".."
                                              }
                                            />
                                          </td>

                                          <td className="table-text text-capitalize align-middle text-center">
                                            <input
                                              type="number"
                                              step={qtyAmountPoints()}
                                              min="0"
                                              onKeyDown={(evt) =>
                                                [
                                                  "e",
                                                  "E",
                                                  "+",
                                                  "-",
                                                  "ArrowUp",
                                                  "ArrowDown",
                                                ].includes(evt.key) &&
                                                evt.preventDefault()
                                              }
                                              onWheel={(e) => e.target.blur()}
                                              className="form-control text-center table-Input table-text"
                                              id={item.id}
                                              name={item.id}
                                              onChange={(e) =>
                                                handleItemQty(index, e)
                                              }
                                              value={item.qty || ""}
                                              placeholder="Qty"
                                              required
                                              disabled={newStoreRequisition?.is_post}  
                                            />
                                          </td>

                                          <td className="table-text text-capitalize align-middle text-center">
                                            {item.unit.name}
                                          </td>
                                          <td
                                            className="table-text text-capitalize align-middle text-center"
                                            style={{ minWidth: "60px" }}
                                          >
                                            <i
                                              className="fa fa-minus-circle cursor-pointer text-danger"
                                              style={{ fontSize: "22px" }}
                                              onClick={() => {
                                                delRow(item.id);
                                              }}
                                            ></i>
                                            &nbsp;
                                            {index == newRow.length - 1 && (
                                              <span
                                                className="t-mr-10"
                                                onClick={() => addNewRow()}
                                              >
                                                <i
                                                  className="fa fa-plus-circle cursor-pointer btn-add-icon"
                                                  style={{ fontSize: "22px" }}
                                                  aria-hidden="true"
                                                ></i>
                                              </span>
                                            )}
                                          </td>
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                ) : null}
                                {/* {newRow && newRow.length>0 ?
                                    <tfoot className="align-middle">
                                      <tr>
                                        <th
                                          scope="col"
                                          colSpan="1"
                                          className="sm-text text-capitalize align-middle text-center border-1 border"
                                        ></th>

                                        <th
                                          scope="col"
                                          colSpan="3"
                                          className="sm-text text-capitalize align-middle text-center border-1 border"
                                        ></th>

                                        <th
                                          scope="col"
                                          className="table-text text-capitalize align-middle text-center border-1 border"
                                        >
                                          <span style={{fontWeight:"bold"}}>
                                              {_t(t("Total"))}
                                          </span>
                                        </th>

                                        <th
                                          scope="col"
                                          className="table-text text-capitalize align-middle text-center border-1 border"
                                        >
                                          <span style={{fontWeight:"bold"}}>
                                            {formatPrice(handleAmount())}
                                          </span>
                                        </th>

                                        <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      ></th>

                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      ></th>

                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      ></th>

                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      ></th>
                                      </tr>
                                    </tfoot>
                                    :null} */}
                              </table>
                            </div>

                            <div className="d-flex justify-content-end align-items-center">
                              <div className="col-3 d-flex justify-content-end">
                                <button
                                  type="button"
                                  className="btn rounded hov-btn mr-3"
                                  onClick={() =>
                                    history.push(
                                      "/dashboard/manage/stock/store-requisition-dept"
                                    )
                                  }
                                  //   data-dismiss="modal"
                                >
                                  <i
                                    class="fa fa-arrow-left"
                                    aria-hidden="true"
                                  ></i>{" "}
                                  {_t(t("Back"))}
                                </button>
                                <button
                                  disabled={loading}
                                  type="submit"
                                  className="btn btn-primary rounded"
                                >
                                  <i
                                    class="fa fa-floppy-o"
                                    aria-hidden="true"
                                  ></i>{" "}
                                  {_t(t("Save"))}
                                </button>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* Rightbar contents end*/}
          </div>
        </div>
      </main>
      {/* main body ends */}
    </>
  );
};

export default StoreRequisitionDeptAction;
